import { useEffect } from 'react';

import { useAnalyticsContext } from '../../../modules/analytics/AnalyticsContext';
import type { TrackPageOptions } from '../../../modules/analytics/types';

export default (
  eventName: string,
  page: string,
  flow: string = '',
  pageOptions: TrackPageOptions = {},
) => {
  const {
    analytics: { trackPageView },
  } = useAnalyticsContext();
  const {
    passwordlessAuthentication,
    isPrivacyConsentOptedIn,
    isMarketingConsentOptedIn,
  } = pageOptions;

  useEffect(() => {
    trackPageView({
      eventName,
      page,
      authenticationFlow: flow,
      passwordlessAuthentication,
      isPrivacyConsentOptedIn,
      isMarketingConsentOptedIn,
    });
  }, [
    trackPageView,
    eventName,
    page,
    flow,
    passwordlessAuthentication,
    isPrivacyConsentOptedIn,
    isMarketingConsentOptedIn,
  ]);
};
